module.exports = __webpack_public_path__ + "static/media/corporate-services-img20.e3992649.jpg";